import React, { useState, useEffect } from "react";
import Logo from "../assets/Logo2.jpg";
import { USER } from "../config/constants.js";
import Modal from "./Modal.js";
import "./MainHeader.css";
import { COLORS } from "../config/theme.js";
import { STRINGS } from "../dictionaries/ESP.dictionary.js";
import { Grid, TextField } from '@mui/material';
import { notification } from "antd";
import { Popover } from 'antd';
import { Button, Typography, Divider } from '@mui/material';
import ButtonComponent from "../components/ButtonComponent";
import { actualizarPassword } from "../services/usuarios.service";


export default function MainHeader(props) {
  const [user, setUser] = useState(null);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("CAMBIAR CONTRASEÑA");
  const [modalContent, setModalContent] = useState(null);
  const [isVisiblePopover, setIsVisiblePopover] = useState(false);
  const [isVisiblePasswordModal, setIsVisiblePasswordModal] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const logedUsr = JSON.parse(localStorage.getItem(USER));
    setUser(logedUsr);
  }, []);

  function getUserTypeName() {
    switch (user?.id_tipo_us) {
      case 0:
        return "Interno";
      case 1:
        return "Profesional";
      case 2:
        return "Particular";
      default:
        return "";
    }
  }

  const handlePasswordChange = async () => {
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    user.password = password;
    const resp = await actualizarPassword(user);
    notification["success"]({
      message: resp?.data?.message || "Modificación de password exitosa",
      });
    setIsVisiblePasswordModal(false);
  };

  const popoverContent = (
    <div style={{ padding: '16px', maxWidth: '250px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontWeight="bold" style={{fontSize: '1.1rem' }}>
            {user?.nombre || 'Usuario'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" style={{fontSize: '1.1rem' }}>
            {user?.mail || 'Email no disponible'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" style={{fontSize: '1.1rem' }}>
            {getUserTypeName()}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => {
              setIsVisiblePopover(false);
              setIsVisiblePasswordModal(true);
            }}
          >
            Cambiar contraseña
          </Button>
        </Grid>
      </Grid>
    </div>
  );

  const passwordModalContent = (
    <form>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Nueva contraseña"
            type="password"
            value={password}
            size="small"
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Reingresar contraseña"
            type="password"
            value={confirmPassword}
            size="small"
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
            variant="outlined"
          />
        </Grid>
        {error && (
          <Grid item xs={12}>
            <p style={{ color: 'red' }}>{error}</p>
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <ButtonComponent
              name={"Cambiar password"}
              color={COLORS.SECONDARY}
              toAction={handlePasswordChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <ButtonComponent
              name={"Cancelar"}
              color={COLORS.DANGER}
              toAction={() => setIsVisiblePasswordModal(false)}
          />          
        </Grid>
      </Grid>
    </form>
  );
  

  return (
    <>
      <div className="menu-top" style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}>
        <div style={{ justifyContent: "center", alignItems: "center", display: "flex", paddingTop: "0.5rem", backgroundColor: COLORS.MAIN }}>
          <img className="menu-top__left-logo" src={Logo} alt="Logo" onClick={() => (window.location.href = `/`)} style={{ width: "100%", height: "53px" }} />
        </div>
        <div className="titlePlatformMenuTop">
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", height: "60px", overflow: "hidden", position: "relative" }}>
            <span>{STRINGS.TITLE_PLATFORM}</span>
          </div>
        </div>
        <div className="user-info-container">
          <div className="user-info">
            <Popover
              placement="bottomRight"
              content={popoverContent}
              trigger="click"
              open={isVisiblePopover}
              onOpenChange={(visible) => setIsVisiblePopover(visible)}
            >
              <span style={{ fontWeight: "bold", cursor: "pointer" }}>
                {user?.nombre || ""}
              </span>
            </Popover>
            <span>{getUserTypeName()}</span>
          </div>
        </div>
      </div>
      <Modal title={modalTitle} isVisible={isVisiblePasswordModal} setIsVisible={setIsVisiblePasswordModal} className="passwordModal">
        {passwordModalContent}
      </Modal>
    </>
  );
}
